// src/graphql/mutations/sessionMutations.js

export const adminDeleteSession = `mutation AdminDeleteSession($id: String!) {
    adminDeleteSession(id: $id) {
        success
        message
        error
    }
}`;
